
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 0a2 2 0 012 2v12a2 2 0 01-2 2H4l-4 4V2a2 2 0 012-2h16zM2 2v13.17L3.17 14H18V2H2zm2 3h12v2H4V5zm0 4h9v2H4V9z","fill":"#000"}})])
          )
        }
      }
    